import create from 'zustand';

interface IUseLoginFormStore {
  mfaToken: string | null;
  updateMfaToken(args: string): void;
}

const useCountStore = create<IUseLoginFormStore>((set) => ({
  mfaToken: null,
  updateMfaToken: (token: string) => set({ mfaToken: token }),
}));

export default useCountStore;
